import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import IconReusable from '../../../components/IconReusable';


const QuantityHandler = ({
  value,
  onIncrease,
  onDecrease,
  onChange,
  onBlur,
  onKeyPress,
  variant = 'medium',
  disabled = false,
  min = 0,
  increaseDisabled = false,
}) => {
  const isSmall = variant === 'small';
  
  // Handle input validation - same pattern as CreateDp ProductCard
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^\d*\.?\d{0,3}$/.test(value)) {
      if (onChange) onChange(event);
    }
  };
  
  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: isSmall ? 1 : 2,
      px: isSmall ? '0px' : '2px'
    },
    iconButton: {
        p: 0
    },
    textField: {
        width: `${Math.max(2, value.toString().length) * (isSmall ? 8 : 10)}px`,
        '& .MuiInput-underline:before': { borderBottom: 'none' },
        '& .MuiInput-underline:after': { borderBottom: 'none' },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
    },
    input: {
      textAlign: 'center',
    }
  };

  return (
    <Box sx={{ 
        border: '1px solid #ccc',
        borderRadius: 1, 
        height: isSmall ? '32px' : '40px', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: isSmall ? 0.5 : 1,    
    }}>
        <Box sx={styles.container}>
        <IconButton
            size={isSmall ? '16px' : '24px'}
            onClick={onDecrease}
            disabled={disabled || parseFloat(value) <= min}
            sx={styles.iconButton}
        >
            <IconReusable name='Minus' size={ isSmall ? '16px' : '24px'} />
        </IconButton>
        <TextField
            value={value}
            onChange={handleInputChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            variant="standard"
            disabled={disabled}
            inputProps={{
            style: styles.input,
                min: min,
                step: 0.001
            }}
            sx={styles.textField}
        />
        <IconButton
            size={ isSmall ? '16px' : '24px'}
            onClick={onIncrease}
            disabled={disabled || increaseDisabled}
            sx={styles.iconButton}
        >   
            <IconReusable name='Add' size={ isSmall ? '16px' : '24px'} />
        </IconButton>
        </Box>
    </Box>
  );
};

export default QuantityHandler;
